import React, { useState } from "react";
import { Quote, Star, ArrowLeft, ArrowRight } from "lucide-react";
import { testimonials } from "../mock";
import { SectionLabel } from "../components/common";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);

  return (
    <section className="py-24 bg-[#F1F3F7] overflow-hidden">
      <div className="max-w-[1100px] mx-auto px-5 text-center">
        <div className="flex justify-center"><SectionLabel>Our Testimonials</SectionLabel></div>
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#CD0008] text-white mb-8">
          <Quote size={30} />
        </span>
        <div className="flex justify-center gap-1 mb-6">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={22} className="fill-[#CD0008] text-[#CD0008]" />
          ))}
        </div>
        <p className="font-display font-medium text-[#0B102D] text-xl md:text-3xl leading-relaxed mb-10 transition-all">
          “{t.text}”
        </p>
        <div>
          <h4 className="font-display font-bold text-[#0B102D] text-lg">{t.name}</h4>
          <p className="text-[#CD0008] text-sm uppercase tracking-wide">{t.role}</p>
        </div>
        <div className="flex items-center justify-center gap-4 mt-10">
          <button onClick={prev} aria-label="Previous" className="w-12 h-12 rounded-full border border-[#0B102D]/20 hover:bg-[#CD0008] hover:border-[#CD0008] hover:text-white text-[#0B102D] flex items-center justify-center transition-colors">
            <ArrowLeft size={20} />
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to testimonial ${i + 1}`}
                className={`h-2.5 rounded-full transition-all ${i === idx ? "w-7 bg-[#CD0008]" : "w-2.5 bg-[#0B102D]/20"}`}
              />
            ))}
          </div>
          <button onClick={next} aria-label="Next" className="w-12 h-12 rounded-full border border-[#0B102D]/20 hover:bg-[#CD0008] hover:border-[#CD0008] hover:text-white text-[#0B102D] flex items-center justify-center transition-colors">
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
